// globals.ts
export const DATABASE_URL = "https://api.findfish.dev";
export const API_KEY = "b8c0f7ef-0168-4e7c-bf77-b4c9bf5eab48"